import AdSideOrderComplete from './AdSideOrderComplete.vue'

export default AdSideOrderComplete
